import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ModeBupRoute from '@BUP/routes/ModeBupRoute'
import LogbookRoute from '@BUP/routes/logbook'
import DataNavigation from '@BUP/navigations/DataNavigation'
import CourseNavigation from '@BUP/navigations/CourseNavigation'
import MySchoolNavigation from '@BUP/navigations/MySchoolNavigation'
import ResourcesNavigation from '@BUP/navigations/ResourcesNavigation'
import ModeBupNavigation from '@BUP/navigations/ModeBupNavigation'
import LogbookNavigation from '@BUP/navigations/logbook'
import SociogramNavigation from '@BUP/navigations/SociogramNavigation'
import CourseAssignmentNavigation from '@BUP/navigations/CourseAssignmentNavigation'
import MainLayout from '@BUP/components/Layout/Main'
import HomePage from '@BUP/pages/Home'
import FinanceHomeGuard from '@BUP/routes/FinanceHomeGuard'
import ProfilePage from '@BUP/pages/Profile'
import WorkGroupPage from '@BUP/pages/Data/sociogram/workGroupPage'
import { UserContextProvider } from '@BUP/contexts/UserContext'
import { EnrollmentContextProvider } from '@BUP/contexts/EnrollmentContext'
import { IsParticipantContextProvider } from '@BUP/contexts/IsParticipantContext'
import { DiagnosisContextProvider } from '@BUP/contexts/DiagnosisContext'
import { UtilsProvider } from '@BUP/contexts/utils-provider'

const AppNavigation = () => {
  return (
    <UserContextProvider>
      <EnrollmentContextProvider>
        <IsParticipantContextProvider>
          <DiagnosisContextProvider>
            <UtilsProvider>
              <MainLayout>
                <Routes>
                  <Route
                    path='/'
                    element={
                      <FinanceHomeGuard>
                        <HomePage />
                      </FinanceHomeGuard>
                    }
                  />
                  <Route
                    path='/course/*'
                    element={<CourseNavigation />}
                  />
                  <Route
                    path='/schoolpage/*'
                    element={<MySchoolNavigation />}
                  />
                  <Route
                    path='/profile'
                    element={<ProfilePage />}
                  />
                  <Route
                    path='/data/*'
                    element={<DataNavigation />}
                  />
                  <Route
                    path='/resources/*'
                    element={<ResourcesNavigation />}
                  />
                  <Route
                    path='/sociogram/*'
                    element={<SociogramNavigation />}
                  />
                  <Route
                    path='/course-assignment/*'
                    element={<CourseAssignmentNavigation />}
                  />
                  <Route
                    path='/modebup/*'
                    element={
                      <ModeBupRoute>
                        <ModeBupNavigation />
                      </ModeBupRoute>
                    }
                  />
                  <Route
                    path='/logbook/*'
                    element={
                      <LogbookRoute>
                        <LogbookNavigation />
                      </LogbookRoute>
                    }
                  />
                  <Route
                    path='/work-group-page'
                    element={<WorkGroupPage />}
                  />
                </Routes>
              </MainLayout>
            </UtilsProvider>
          </DiagnosisContextProvider>
        </IsParticipantContextProvider>
      </EnrollmentContextProvider>
    </UserContextProvider>
  )
}

export default AppNavigation
